/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgDatabase(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M4.171 4.421c-.37.292-.421.493-.421.579 0 .086.052.287.421.579.362.285.932.574 1.702.83 1.534.512 3.7.841 6.127.841 2.427 0 4.593-.329 6.127-.84.77-.257 1.34-.546 1.701-.831.37-.292.422-.493.422-.579 0-.086-.052-.287-.422-.579-.361-.285-.93-.574-1.701-.83-1.534-.512-3.7-.841-6.127-.841-2.427 0-4.593.329-6.127.84-.77.257-1.34.546-1.702.831zM20.25 7.103a8.448 8.448 0 01-1.649.73c-1.724.574-4.057.917-6.601.917-2.543 0-4.877-.343-6.601-.917a8.449 8.449 0 01-1.649-.73V12c0 .09.053.291.419.581.359.285.925.574 1.694.83 1.529.51 3.695.839 6.137.839 2.442 0 4.608-.328 6.137-.839.769-.256 1.335-.545 1.694-.83.366-.29.419-.492.419-.581V7.103zM21.75 5c0-.743-.452-1.33-.993-1.757-.55-.433-1.298-.79-2.156-1.076-1.724-.574-4.057-.917-6.601-.917-2.543 0-4.877.343-6.601.917-.858.286-1.607.643-2.156 1.076C2.703 3.67 2.25 4.257 2.25 5v14c0 .74.447 1.329.987 1.757.548.434 1.294.791 2.15 1.077 1.721.574 4.055.916 6.613.916 2.558 0 4.892-.342 6.613-.916.856-.286 1.602-.643 2.15-1.077.54-.428.987-1.016.987-1.757V5zm-1.5 9.108a8.394 8.394 0 01-1.637.726c-1.721.574-4.055.916-6.613.916-2.558 0-4.892-.342-6.612-.916a8.393 8.393 0 01-1.638-.726V19c0 .09.053.291.419.581.359.285.925.573 1.694.83 1.529.51 3.695.839 6.137.839 2.442 0 4.608-.328 6.137-.839.769-.257 1.335-.545 1.694-.83.366-.29.419-.492.419-.581v-4.892z'
      />
    </svg>
  );
}

export default SvgDatabase;
